"use strict";
import React from "react";
import { infoIcon, arrowDown, arrowUp } from "../ui/header_icons";
import { Tooltip, TooltipDirection, TooltipLocation } from "../ui/v3/tooltip";
var CustomerMarginHeaderTooltipPlacement = /* @__PURE__ */ ((CustomerMarginHeaderTooltipPlacement2) => {
  CustomerMarginHeaderTooltipPlacement2["Before"] = "before";
  CustomerMarginHeaderTooltipPlacement2["After"] = "after";
  return CustomerMarginHeaderTooltipPlacement2;
})(CustomerMarginHeaderTooltipPlacement || {});
class CustomerMarginHeader extends React.Component {
  renderCustomerMargin() {
    var _a, _b;
    const dollarDifference = ((_a = this.props.invoice.customer_margin_data) == null ? void 0 : _a.dollarDifference) || 0;
    const dollarDifferenceString = this.formatDollars(dollarDifference);
    const percentDifference = ((_b = this.props.invoice.customer_margin_data) == null ? void 0 : _b.percentDifference) || 0;
    let icon;
    let percentString;
    if (percentDifference == 0) {
      icon = "";
      percentString = "";
    } else if (percentDifference < 0) {
      icon = arrowDown();
      percentString = `${Math.abs(percentDifference)}%`;
    } else {
      icon = arrowUp();
      percentString = `${percentDifference}%`;
    }
    let dangerStyle = {};
    if (dollarDifference < 0) {
      dangerStyle = { color: "var(--color-danger-700)" };
    }
    return /* @__PURE__ */ React.createElement("div", { className: "v3__stack--horz v3__stack v3__stack--gap-xxxs" }, /* @__PURE__ */ React.createElement("div", { className: "v3__stack-cell v3__stack-cell--size-fit" }, /* @__PURE__ */ React.createElement("span", { className: "v3__type__small-body", style: dangerStyle }, dollarDifferenceString)), /* @__PURE__ */ React.createElement("div", { className: "v3__stack-cell v3__stack-cell--size-fit" }, /* @__PURE__ */ React.createElement("span", { style: dangerStyle }, icon)), /* @__PURE__ */ React.createElement("div", { className: "v3__stack-cell v3__stack-cell--size-fit" }, /* @__PURE__ */ React.createElement("span", { className: "v3__type__small-body", style: dangerStyle }, percentString)));
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "enable_shared-ui-v3" }, /* @__PURE__ */ React.createElement("div", { className: "v3__theme" }, /* @__PURE__ */ React.createElement("div", { className: "v3__stack--horz v3__stack v3__stack--gap-xxxs" }, this.props.tooltipPlacement === "before" /* Before */ && this.renderTooltip(), /* @__PURE__ */ React.createElement("div", { className: "v3__stack-cell v3__stack-cell--size-fit" }, /* @__PURE__ */ React.createElement(
      "span",
      {
        className: this.props.useV3Typography ? "v3__type__small-body-semi-bold" : ""
      },
      "Customer margin",
      this.props.labelValueSeparator || ""
    )), /* @__PURE__ */ React.createElement("div", { className: "v3__stack-cell v3__stack-cell--size-fit" }, /* @__PURE__ */ React.createElement(
      "span",
      {
        className: this.props.useV3Typography ? "v3__type__small-body" : ""
      },
      this.renderCustomerMargin()
    )), this.props.tooltipPlacement === "after" /* After */ && this.renderTooltip())));
  }
  formatDollars(amount) {
    if (amount < 0) {
      return `-$${Math.abs(amount).toFixed(2)}`;
    } else if (amount > 0) {
      return `$${amount.toFixed(2)}`;
    } else {
      return "$0.00";
    }
  }
  renderTooltip() {
    var _a, _b;
    const customerCharge = ((_a = this.props.invoice.customer_margin_data) == null ? void 0 : _a.customerCharge) || 0;
    const carrierCharge = ((_b = this.props.invoice.customer_margin_data) == null ? void 0 : _b.carrierCharge) || 0;
    const toolTipContent = `Calculated as invoiced payable (${this.formatDollars(carrierCharge)}) deducted from the receivable (${this.formatDollars(customerCharge)}).`;
    return /* @__PURE__ */ React.createElement("div", { className: "v3__stack-cell v3__stack-cell--size-fit" }, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
      Tooltip,
      {
        content: infoIcon(),
        tooltipContent: toolTipContent,
        direction: TooltipDirection.Below,
        location: TooltipLocation.Middle,
        tooltipContentStyle: {
          width: "200px",
          top: "-10px",
          left: "-93px"
        }
      }
    )));
  }
}
export { CustomerMarginHeader, CustomerMarginHeaderTooltipPlacement };
